'use client';


import { usePushNotifications, useInAppNotifications } from '@/hooks/usePushNotifications';

export default function PushNotificationInit() {
  usePushNotifications();
  useInAppNotifications();
  return null;
}
